/*                                     */
/**
 *
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/async/namespaces";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 *
 */
export const attributeParser = /*           */ asExport(o_util, "attributeParser", {});
/**
 *
 *
 */
export const parseParameters = /*           */ asExport(attributeParser, "parseParameters", noop);
/**
 *
 */
export const parseAttributeName = /*           */ asExport(attributeParser, "parseAttributeName", noop);
/**
 *
 *
 *
 */
export const mergeParameterValues = 
/*           */ asExport(attributeParser, "mergeParameterValues", noop);
